import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_ESTONIAN_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Number', 'Kaardi number'],
    cardExpiry: ['Aegumine', 'Aegumiskuupäev'],
};

export const TUI_ESTONIAN_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Populaarne',
        history: 'Hiljutine',
        placeholder: 'Otsi',
        hotkey: 'otsimiseks',
        all: 'Kõik',
        empty: 'Tulemused puuduvad',
    },
};

export const TUI_ESTONIAN_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Tühista',
    done: 'Valmis',
    more: 'Rohkem',
    otherDate: 'Muu kuupäev...',
    showAll: 'Näita kõiki',
    hide: 'Peida',
    mobileCalendarTexts: [
        'Vali päev',
        'Vali periood',
        'Vali päevad',
    ],
    range: ['Alates', 'Kuni'],
    countTexts: ['Rohkem', 'Vähem'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'päev.kuu.aasta',
        MDY: 'kuu.päev.aasta',
        YMD: 'aasta.kuu.päev',
    },
    digitalInformationUnits: ['Bait', 'Kilobait', 'Megabait'],
    passwordTexts: ['Näita parooli', 'Peida parool'],
    copyTexts: ['Kopeeri', 'Kopeeritud'],
    shortCalendarMonths: [
        'Jaan',
        'Veebr',
        'Märts',
        'Apr',
        'Mai',
        'Juuni',
        'Juuli',
        'Aug',
        'Sept',
        'Okt',
        'Nov',
        'Dets',
    ],
    pagination: ['Eelmine leht', 'Järgmine leht'],
    fileTexts: {
        loadingError: 'Laadimise viga',
        preview: 'Eelvaade',
        remove: 'Eemalda',
    },
    inputFileTexts: {
        defaultLabelSingle: 'või lohista siia',
        defaultLabelMultiple: 'või lohista siia',
        defaultLinkSingle: 'Vali fail',
        defaultLinkMultiple: 'Vali failid',
        maxSizeRejectionReason: 'Fail on liiga suur',
        formatRejectionReason: 'Vigane failivorming',
        drop: 'Lohista fail siia',
        dropMultiple: 'Lohista failid siia',
    },
    multiSelectTexts: {
        all: 'Vali kõik',
        none: 'Ära vali midagi',
    },
    confirm: {
        yes: 'Jah',
        no: 'Ei',
    },
    previewTexts: {
        rotate: 'Pööra',
    },
    zoomTexts: {
        zoomOut: 'Vähenda',
        zoomIn: 'Suurenda',
        reset: 'Lähtesta',
    },
    phoneSearch: 'Otsi riiki või koodi',
};

export const TUI_ESTONIAN_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Ühevärviline', 'Värvigradient'],
    toolbarTools: {
        undo: 'Võta tagasi',
        redo: 'Tee uuesti',
        font: 'Font',
        fontStyle: 'Fondi stiil',
        fontSize: 'Fondi suurus',
        bold: 'Rasvane',
        italic: 'Kaldkiri',
        underline: 'Allakriipsutatud',
        strikeThrough: 'Läbikriipsutatud',
        justify: 'Joonda',
        justifyLeft: 'Joonda vasakule',
        justifyCenter: 'Joonda keskele',
        justifyRight: 'Joonda paremale',
        justifyFull: 'Joonda mõlemale poole',
        list: 'Nimekiri',
        indent: 'Suurenda taanet',
        outdent: 'Vähenda taanet',
        unorderedList: 'Täpploend',
        orderedList: 'Nummerdatud loend',
        quote: 'Tsitaat',
        foreColor: 'Teksti värv',
        backColor: 'Tausta värv',
        hiliteColor: 'Esiletõstmise värv',
        clear: 'Tühjenda',
        link: 'Link',
        attach: 'Lisa fail',
        tex: 'Lisa TeX',
        code: 'Kood',
        image: 'Lisa pilt',
        insertHorizontalRule: 'Lisa horisontaaljoon',
        superscript: 'Ülaindeks',
        subscript: 'Alaindeks',
        insertTable: 'Lisa tabel',
        insertGroup: 'Lisa grupp',
        hiliteGroup: 'Tõsta grupp esile',
        removeGroup: 'Eemalda grupp',
        insertAnchor: 'Lisa ankur',
        mergeCells: 'Ühenda lahtrid',
        splitCells: 'Jaga lahtrid',
        rowsColumnsManaging: 'Halda ridu ja veerge',
        cellColor: 'Lahtri värv',
        setDetails: 'Määra üksikasjad',
        removeDetails: "Eemalda üksikasjad",
    },
    editorEditLink: {
        urlExample: 'näide.com',
        anchorExample: 'ankur',
    },
    editorTableCommands: [
        ['Lisa veerg enne', 'Lisa veerg pärast'],
        ['Lisa rida enne', 'Lisa rida pärast'],
        ['Eemalda veerg', 'Eemalda rida'],
    ],
    editorCodeOptions: ['Kood tekstis', 'Koodiplokk'],
    editorFontOptions: {
        small: 'Väike',
        large: 'Suur',
        normal: 'Tavaline',
        title: 'Pealkiri',
        subtitle: 'Alapealkiri',
    },
};

export const TUI_ESTONIAN_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Näita/Peida',
    paginationTexts: {
        pages: 'Leheküljed',
        linesPerPage: 'Ridu leheküljel',
        of: 'kokku',
    },
};

export const TUI_ESTONIAN_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Jaanuar',
        'Veebruar',
        'Märts',
        'Aprill',
        'Mai',
        'Juuni',
        'Juuli',
        'August',
        'September',
        'Oktoober',
        'November',
        'Detsember',
    ],
    close: 'Sulge',
    clear: 'Tühjenda',
    nothingFoundMessage: 'Tulemused puuduvad',
    defaultErrorMessage: 'Vigane väärtus',
    spinTexts: ['Eelmine', 'Järgmine'],
    shortWeekDays: ['E', 'T', 'K', 'N', 'R', 'L', 'P'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_ESTONIAN_LANGUAGE: TuiLanguage = {
    name: 'estonian',
    ...TUI_ESTONIAN_LANGUAGE_CORE,
    ...TUI_ESTONIAN_LANGUAGE_KIT,
    ...TUI_ESTONIAN_LANGUAGE_ADDON_TABLE,
    ...TUI_ESTONIAN_LANGUAGE_ADDON_COMMERCE,
    ...TUI_ESTONIAN_LANGUAGE_ADDON_EDITOR,
    ...TUI_ESTONIAN_LANGUAGE_LAYOUT,
};